export default "__VITE_ASSET__rIVUdplo__"